import React from "react";
import Icon from "../../../components/AppIcon";

const CTASection = () => {
  return (
    <section className="py-12 md:py-16 lg:py-20 px-4 md:px-6 lg:px-8 bg-gradient-to-br from-primary via-secondary to-primary">
      <div className="max-w-7xl mx-auto">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
            <Icon name="Zap" size={20} color="#ffffff" />
            <span className="text-sm font-semibold text-white">
              Ready to Transform?
            </span>
          </div>

          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4">
            Let's Build Your Digital Future Together
          </h2>

          <p className="text-base md:text-lg text-white/90 max-w-2xl mx-auto mb-8">
            Join 196+ satisfied clients who trust Orator Hype for their IT
            infrastructure and branding needs. Get started with a free
            consultation today.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <button className="bg-inherit text-primary px-8 py-4 rounded-lg font-semibold hover:shadow-2xl transition-all duration-300 flex items-center gap-2">
              <Icon name="Calendar" size={20} />
              sales@oratorhype.com
            </button>
            <button className="bg-white/20 backdrop-blur-sm text-white px-8 py-4 rounded-lg font-semibold hover:bg-white/30 transition-all duration-300 flex items-center gap-2">
              <Icon name="Phone" size={20} />
              Call: +91 73046 60050
            </button>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-4xl mx-auto">
            {[
              {
                icon: "Clock",
                label: "24/7 Support",
                value: "Always Available",
              },
              {
                icon: "Shield",
                label: "Secure Solutions",
                value: "Enterprise-Grade",
              },
              {
                icon: "TrendingUp",
                label: "Proven ROI",
                value: "35%+ Savings",
              },
              {
                icon: "Users",
                label: "Expert Team",
                value: "13+ Years Experience",
              },
            ]?.map((item, index) => (
              <div
                key={index}
                className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center"
              >
                <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mx-auto mb-3">
                  <Icon name={item?.icon} size={24} color="#ffffff" />
                </div>
                <div className="text-sm text-white/80 mb-1">{item?.label}</div>
                <div className="text-base font-bold text-white">
                  {item?.value}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
